import React, { FC } from 'react';

const CarElectricIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="23"
    viewBox="0 0 13 23"
  >
    <rect width="13" height="23" fill="#fff" opacity="0" />
    <path
      d="M10.2,7.7a.8.8,0,0,0-.8-.6H3.5a.8.8,0,0,0-.8.6L1.6,10.9v4.3a.6.6,0,0,0,.5.6h.6a.6.6,0,0,0,.5-.6v-.5H9.7v.5a.6.6,0,0,0,.6.6h.5a.6.6,0,0,0,.5-.6V10.9Zm-6.5.5H9.2l.6,1.7H3.1Zm6.6,5.4H2.7V10.9h7.6Z"
      transform="translate(0)"
      fill="#666"
    />
    <path
      d="M4,13.1a.8.8,0,0,0,.8-.8.7.7,0,0,0-.8-.8.8.8,0,0,0-.8.8A.9.9,0,0,0,4,13.1Z"
      transform="translate(0)"
      fill="#666"
    />
    <path
      d="M8.9,13.1a.9.9,0,0,0,.8-.8.8.8,0,0,0-.8-.8.7.7,0,0,0-.8.8A.8.8,0,0,0,8.9,13.1Z"
      transform="translate(0)"
      fill="#666"
    />
    <path
      d="M3.8,18.7H6V17.6l3.2,1.6H7v1.1Z"
      transform="translate(0)"
      fill="#666"
    />
  </svg>
);

export default CarElectricIcon;
